import { useState } from "react";
import { useLoggerContext } from "@classdojo/web";
import { DevToolsSettings } from "#/src/utils/devTools";
import { useEnsureFeatureSwitches, useFetchedFeatureSwitchesWithOverrides } from "@web-monorepo/feature-switches";
import { useSessionQuery } from "#/src/hooks/useSession";
import { useOnFirstRender } from "@web-monorepo/hooks";
import MarketplaceAutomaticClickLogger from "#/src/pages/_components/MarketplaceAutomaticClickLogger";

const EnsureSessionLoaded = ({ children }: { children: React.ReactElement }) => {
  const { isInitialLoading } = useSessionQuery();
  if (isInitialLoading) return null;

  return <EnsureFeatureSwitchesLoaded>{children}</EnsureFeatureSwitchesLoaded>;
};

// needs to fetch the feature switches after they've been ensured
const SetupLoggerContext = () => {
  const fetchedFeatureSwitches = useFetchedFeatureSwitchesWithOverrides();

  const { setPanelDisplaySide } = DevToolsSettings.usePanelDisplaySide();

  useOnFirstRender(() => {
    setPanelDisplaySide("left");
  });

  useLoggerContext({ prefix: "marketplace", fetchedFeatureSwitches });

  return null;
};

const EnsureFeatureSwitchesLoaded = ({ children }: { children: React.ReactElement }) => {
  const [featureSwitchesLoaded, setFeatureSwitchesLoaded] = useState(false);
  const { ready } = useEnsureFeatureSwitches();
  if (ready && featureSwitchesLoaded === false) {
    setFeatureSwitchesLoaded(true);
  }

  if (!featureSwitchesLoaded) return null;

  return (
    <>
      <SetupLoggerContext />
      <MarketplaceAutomaticClickLogger />
      {children}
    </>
  );
};

export default EnsureSessionLoaded;
